import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ViewUI from 'view-design';
import 'view-design/dist/styles/iview.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import elTableInfiniteScroll from 'el-table-infinite-scroll';
 
// 导入全局样式表
import './assets/css/global.less'

// 引入MOCK
//公共mock
// import './mock/public'

Vue.use(ViewUI);
Vue.use(ElementUI);
Vue.use(elTableInfiniteScroll);

// 时间过滤器
Vue.filter('dateFormat', function (dateStr, pattern = '') {
  //根据给定的时间字符串，得到特定的时间

  var dt = new Date(dateStr) //yyy---mm-dd
  var y = dt.getFullYear() //得到年份
  var m = (dt.getMonth() + 1 + '').padStart(2, '0') //得到月份

  var d = (dt.getDate() + '').padStart(2, '0') //得到日期
  // return y + '-' + m + '-' + d

  if (pattern.toLowerCase() === 'yyy-mm-dd') { return `${y}-${m}-${d}` } else {
    var hh = (dt.getHours() + '').padStart(2, '0') //得到时
    var mm = (dt.getMinutes() + '').padStart(2, '0') //得到分
    var ss = (dt.getSeconds() + '').padStart(2, '0') //得到秒
    return `${y}-${m}-${d} ${hh}:${mm}:${ss}`
  }
})


Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
